import { PropsWithChildren } from 'react';

import { GeneralCardData } from 'src/types/components';

import Image from 'components/BaseHelpers/Image';
import Link from 'components/BaseHelpers/Link';
import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import styles from './GeneralCard.module.scss';

type DivWrapperProps = {
  className?: string;
};
const DivWrapper = (props: PropsWithChildren<DivWrapperProps>): JSX.Element => (
  <div className={props.className}>{props.children}</div>
);

export type GeneralCardProps = GeneralCardData;

const GeneralCard = ({ cardCopy, link, date, image }: GeneralCardProps): JSX.Element => {
  const { eyebrow, heading, description } = cardCopy;

  const hasLink = link?.href;
  const LinkOrDiv = hasLink ? Link : DivWrapper;

  return (
    <article className={styles.wrapper}>
      <LinkOrDiv {...link} className={styles.card}>
        {!!image && (
          <figure className={styles.imageWrapper}>
            <Image fill {...image} />
          </figure>
        )}
        <div className={styles.copyWrapper}>
          <div className={styles.innerCopyWrapper}>
            {!!eyebrow && <Text tag="p" field={eyebrow} className={styles.eyebrow} />}
            <Text tag="h3" field={heading} className={styles.heading} />
            {!!description && <RichText field={description} className={styles.description} />}
          </div>
          {!!date.display && (
            <p
              className={styles.date}
              aria-label={date.readable !== '' ? date.readable : date.display}
            >
              {date.display}
            </p>
          )}
        </div>
      </LinkOrDiv>
    </article>
  );
};

export default GeneralCard;
